import React, { createContext, useState } from "react";
import {
  useTodos,
  useProjects,
  useFilterTodos,
  useProjectsWithStats,
} from "../hooks";

const TodoContext = createContext();

function TodoContextProvider({ children }) {
  // STATE
  const defaultProject = "today";
  const [selectedProject, setSelectedProject] = useState(defaultProject);
  const [selectedTodo, setSelectedTodo] = useState(undefined);
  //firebaseden todos ve projects
  const todos = useTodos();
  // const projects = useProjects(todos);
  //bunda artok todos a gerek yok, çünkü stats için ayrı hooks yaptık
  const projects = useProjects();
  const projectsWithStats = useProjectsWithStats(projects, todos);
  //filter uygulanmış todo'lar
  const filteredTodos = useFilterTodos(todos, selectedProject);

  return (
    <TodoContext.Provider
      value={{
        defaultProject,
        selectedProject,
        setSelectedProject,
        //firebaseden todos ve projects
        todos: filteredTodos,
        // projects,
        projects: projectsWithStats,
        selectedTodo,
        setSelectedTodo,
      }}
    >
      {children}
    </TodoContext.Provider>
  );
}

export { TodoContextProvider, TodoContext };
